import { coverInk } from '@/components/covers/cover-tint';
import { GeneratedCover } from '@/components/covers/GeneratedCover';
import { fnv1a } from '@/lib/hash';
import { ReportTemplate } from '@/types/report';
import { getInitials } from '@/utils/getInitials';

/** Matches the `--cover-hue-*` tokens declared in index.css. */
const COVER_HUE_COUNT = 8;

/**
 * Cover art for a template that has no illustration of its own.
 *
 * Everything is derived from `template.id` rather than the name, so renaming a
 * template leaves its cover untouched — the art is an identity, not a label.
 * The hue comes straight off the hash while the geometry comes off a seeded
 * stream, which means tuning the wave ranges later reshuffles the shapes but
 * never recolours anyone's templates.
 */
export const GeneratedTemplateCover = ({ template }: { template: ReportTemplate }) => {
    const hue = `var(--cover-hue-${(fnv1a(template.id) % COVER_HUE_COUNT) + 1})`;

    return (
        <GeneratedCover seed={template.id} hue={hue}>
            {/* Decorative only — the full template name is rendered directly
                below the plate, so announcing the initials would just stutter. */}
            <div className="absolute inset-0 flex items-center justify-center" aria-hidden="true">
                <span
                    className="text-4xl font-semibold tracking-tight"
                    style={{ color: coverInk(hue) }}
                >
                    {getInitials(template.name)}
                </span>
            </div>
        </GeneratedCover>
    );
};
